export const DocumentArrowIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      {...props}
    >
      <g>
        <path
          d="M14 3.33341V0.666748H2V15.3334H14V12.6667"
          strokeWidth="1.33333"
          strokeMiterlimit="10"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M4.66675 4.66675H7.33341"
          strokeWidth="1.33333"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M4.66675 8H14.0001M14.0001 8L12.0001 6M14.0001 8L12.0001 10"
          strokeWidth="1.33333"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M4.66675 11.3333H7.33341"
          strokeWidth="1.33333"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};
